export default __webpack_public_path__ + "static/featured-image-ca9f8c0dccc8bedb3edbadc89ff37d01.jpg";